import { create } from 'zustand';
import { Session, User } from '@supabase/supabase-js';
import { supabase } from '@/lib/supabase';

interface UserStore {
  session: Session | null;
  user: User | null;
  initialized: boolean;
  setSession: (session: Session | null) => void;
  setUser: (user: User | null) => void;
  clearUser: () => void;
  checkSession: () => Promise<void>;
}

export const useUserStore = create<UserStore>((set) => ({
  session: null,
  user: null,
  initialized: false,

  setSession: (session) =>
    set({
      session,
      user: session?.user ?? null,
    }),
  setUser: (user) => set({ user }),
  clearUser: () =>
    set({
      session: null,
      user: null,
    }),

  checkSession: async () => {
    try {
      const {
        data: { session },
        error,
      } = await supabase.auth.getSession();
      if (error) throw error;

      set({
        session,
        user: session?.user ?? null,
        initialized: true,
      });
    } catch (error) {
      console.error('Error checking session:', error);
      set({
        session: null,
        user: null,
        initialized: true,
      });
    }
  },
}));
